import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { NotFoundShell } from "src/routing/components/NotFoundShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";

/**
 * Global catch-all (`*`) when no domain tree matches.
 *
 * Role: data router domain route.
 *
 * Authenticated: `NotFoundShell` → `AuthenticatedShell` → `GlobalNavLayout` → `ScrollableParentLayout` → NotFound.
 * Unauthenticated: `NotFoundShell` renders NotFound directly (no nav, no redirect to `/signIn`).
 *
 * Nested leaf must be `path: "*"`, not `index: true` — RR6 does not match an index route under a splat parent.
 */
export const notFoundChrome: RouteObject = {
  Component: GlobalNavLayout,
  children: [{ Component: ScrollableParentLayout, children: [{ path: "*", Component: NotFound }] }],
};

export const notFoundRoutes: RouteObject[] = [{ path: "*", Component: NotFoundShell, children: [notFoundChrome] }];
